document.documentElement.classList.remove('no-js');

(function(){
  const toggles = document.querySelectorAll('[data-drawer-toggle]');
  const drawer = document.querySelector('[data-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');
  if(!drawer) return;

  function openDrawer(){
    drawer.setAttribute('aria-hidden','false');
    overlay?.classList.add('is-visible');
    document.body.style.overflow='hidden';
  }
  function closeDrawer(){
    drawer.setAttribute('aria-hidden','true');
    overlay?.classList.remove('is-visible');
    document.body.style.overflow='';
  }
  toggles.forEach(btn => btn.addEventListener('click', (e)=>{ e.preventDefault(); openDrawer(); }));
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape') closeDrawer(); });
  document.querySelectorAll('[data-drawer-close]').note?.addEventListener('click', closeDrawer);
  const closeBtn = drawer.querySelector('[data-drawer-close]');
  closeBtn?.addEventListener('click', closeDrawer);
})();
